import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { State } from '../../../models/state.model';
import { CountryService } from '../../../services/country/country.service';
import { Country } from './../../../models/country.model';
import { StateService } from './../../../services/state/state.service';


@Component({
  selector: 'app-kv-state-form',
  templateUrl: 'stateForm.html',
  styles: ['label.required:after {top: 0}']
})

export class StateFormComponent implements OnInit {
  @Output() stateAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() stateUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxState: State;
  addEditForm: FormGroup;
  countries: Array<Country>
  model = {
    country: null
  }
  show = {
    form:false
  }
  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private stateService: StateService,
    private srvCountry: CountryService) {
  }

  ngOnInit(): void {

    this.countries = [];

    let FieldsState =  this.stateService.getFields();
    let Countries = Observable.of(null);

    if(this.dialogBoxState && this.dialogBoxState.country_id){
      let searchCountries = [
        {key: 'id',value: this.dialogBoxState.country_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      Countries = this.srvCountry.list(null,null,searchCountries);
    }


    Observable.zip(
      FieldsState,
      Countries
    ).subscribe(([
      resFields,
      resCountries
    ]) => {
      this.fields = resFields;
      this.countries = [];

      if(resCountries && resCountries.data){
        this.countries = resCountries.data;
        this.model.country = this.countries[0];
      }

      this.addEditForm = this.fb.group({
        'code': new FormControl(this.dialogBoxState.code),
        'name': new FormControl(this.dialogBoxState.name),
        'description': new FormControl(this.dialogBoxState.description),
        'country_id': new FormControl(this.dialogBoxState.country_id)
      });

      this.show.form = true;

    });



  }
/*** Gestione autocomplete Countries */
filterCountrySingle(event){
  if(event){
    let search = [
      {key: 'name',value: event.query},
      {key: 'flg_state',value: "0"}
    ];
    this.srvCountry.list(null,null,search).subscribe(res=>{
      this.countries = [];
      if(res && res.data){
        this.countries = res.data;
      }
    })
  }
}
onSelectCountry(event){
  this.addEditForm.get('country_id').setValue(event.id);
}
onClearCountry(){
  this.addEditForm.get('country_id').setValue(null);
  this.model.country = null;
}
  saveOrUpdate(dialogBoxState: any): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxState, this.addEditForm.value);

    if (!newData.id) {
      this.stateAdded.emit(newData);
    } else {
      this.stateUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/state/stateForm.component.ts